import React from 'react';
import {Switch, Redirect, Route} from 'wouter';

import {useLastLocationEffect} from '../../../hooks/use-last-location-effect';

import {EditView} from './edit-view';
import {GlobalVersionData} from '../../../hooks/global-version/use-global-version-query';

interface Props {
    globalVersions: GlobalVersionData[] | null;
}

export const EditRoute = ({globalVersions}: Props) => {
    useLastLocationEffect({
        path: '/documents/edit',
        lsKey: 'documents.edit.lastLocation'
    });
    return (
        <Switch>
            <Route path="/new/:type">
                {(params) => (
                    <EditView
                        globalVersions={globalVersions}
                        createdDocumentType={params.type as DocType}
                    />
                )}
            </Route>

            <Route path="/:documentId/*?">
                {(params) => (
                    <EditView globalVersions={globalVersions} documentId={params.documentId} />
                )}
            </Route>

            <Route path="">
                <EditView globalVersions={globalVersions} />
            </Route>

            <Route>
                <Redirect to="/" />
            </Route>
        </Switch>
    );
};
